import gql from 'graphql-tag'

export default gql`
mutation sendVirtualCardInvitation($id: ID!, $message: String) {
	cashAssist {
		sendVirtualCardInvitation(id: $id, message: $message) {
			sent
		}
	}
}
`
